import React from 'react'
import { CreditApplication } from '_gql'
import { css } from '@emotion/core'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface ApprovedStatusTileProps {
  creditApp: CreditApplication
}

const ApprovedStatusTile = ({ creditApp }: ApprovedStatusTileProps) => {
  const { statusUpdatedAt } = creditApp || {}
  const [makeTestId] = useNameFormatter('ApprovedStatusTile')

  return (
    <div
      css={approvedStatusTileCss}
      data-testid={makeTestId('')}
    >
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='person with party hat with hands in the air'
            imageName='dashboard-application-approved-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='Be on the lookout for an email from us with next steps on how to set up your BILL Spend & Expense account.'
            id='sputnik.ApprovedStatusTile__02NE58'
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Accepted on {date, date, long}'
            id='sputnik.ApprovedStatusTile__Lu3X2f'
            values={{ date: new Date(statusUpdatedAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Congrats on your new credit line!'
            id='sputnik.ApprovedStatusTile__iy42WV'
          />
        }
      />
    </div>
  )
}

const approvedStatusTileCss = css`
  .Tile-content {
    background-image: url('https://app.divvy.co/assets/backgrounds/confetti_background.png');
    background-position: left;
    background-repeat: repeat;
    background-size: auto;
  }
`

export default ApprovedStatusTile
